import { useState } from "react";
import { getRealm } from "../../../../../AuthProvider";
import { Toast } from "../../../../../components/Toast";
import { usePatientValidateByDob } from "../../../../../queries/patient/use-validate-patient-by-dob";
import { getStartEndDateOfSameDay } from "../../../../../utils/date-time-utility";
import { getErrorSnackbar } from "../../../../../utils/utils";

export const useValidateDob = (
  patientId?: string | null,
  showSnackbar?: (toast: Toast) => void
) => {
  const [birthDate, setBirthDate] = useState<string>();
  const [isAuthenticate, setIsAuthenticate] = useState<boolean>(false);
  const { mutateAsync: verifyDob } = usePatientValidateByDob();
  const hostNameArr = location.hostname?.split(".");
  const xTENANTID = getRealm(hostNameArr);

  const onVerify = () => {
    const { startTime } = getStartEndDateOfSameDay(birthDate);

    verifyDob({
      patientId: patientId!,
      dob: startTime?.split("T")[0] ?? "",
      xTENANTID,
    })
      .then((res) => {
        setIsAuthenticate(!!res?.data?.data);
        if (res?.data?.data)
          showSnackbar?.({ type: "success", message: "Successfully Verified" });
        else
          showSnackbar?.({
            type: "error",
            message:
              "You Are Not Authorized To Access This Feature, Please Enter Valid Date Of Birth",
            // "Selected Birth Date is not Valid, Please Select Valid Date",
          });
      })
      .catch((err) => showSnackbar?.(getErrorSnackbar(err)));
  };

  return { isAuthenticate, birthDate, setBirthDate, onVerify };
};

export const getPublicRealm = () => {
  const hostNameArr = location.hostname?.split(".");
  return getRealm(hostNameArr);
};
